import yup from 'config/yup';

export default yup.object().shape({
  password: yup.string().min(6).required(),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password'), null], 'As senhas não batem'),
});
